<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            登录密码编辑
        </div>
        <div class="user_content_blcok_line"></div>

        <div class="admin_form_main">
            <el-form  label-width="100px" ref="info" :model="info">
                <el-form-item label="旧密码" prop="password" :rules="[{required:true,message:'旧密码不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.password" :type="password.passw1"><img slot="suffix" v-if="password.passw1==='text'" src="@/static/img/public/open.png" @click="showPass1" /><img slot="suffix" v-else src="@/static/img/public/close.png" @click="showPass1" /></el-input></el-form-item>
                <el-form-item label="新密码" prop="newPassword" :rules="[{required:true,message:'新密码不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" type="password" v-model="info.newPassword" :type="password.passw2"><img slot="suffix" v-if="password.passw2==='text'" src="@/static/img/public/open.png" @click="showPass2" /><img slot="suffix" v-else src="@/static/img/public/close.png" @click="showPass2" /></el-input></el-form-item>
                <el-form-item label="确认密码" prop="repassword" :rules="[{required:true,message:'确认密码不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" type="password" v-model="info.repassword" :type="password.passw3"><img slot="suffix" v-if="password.passw3==='text'" src="@/static/img/public/open.png" @click="showPass3" /><img slot="suffix" v-else src="@/static/img/public/close.png" @click="showPass3" /></el-input></el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="submitForm('info')">提交</el-button>
                    <!-- <el-button @click="resetForm('info')">重置</el-button> -->
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { _local } from '@/plugins/local-storage.js'
export default {
    components: {},
    props: {},
    data() {
      return {
        userInfo:{
            nickname:'',
            avatar:'',
            email:'',
            mobile:'',
            gender:''
        },
        info:{
            mobile:'',
            password:'',
            newPassword:'',
            repassword:'',
        },
        password:{
            passw1: 'password',
            passw2: 'password',
            passw3: 'password'
        }
      };
    },
    watch: {},
    computed: {},
    methods: {
        //密码的隐藏和显示
        showPass1(){
　　　　　　 //点击图标是密码隐藏或显示
            if( this.password.passw1=="text"){
                this.password.passw1="password";
            }else {
                this.password.passw1="text";
            }
        },
        showPass2(){
　　　　　　 //点击图标是密码隐藏或显示
            if( this.password.passw2=="text"){
                this.password.passw2="password";
            }else {
                this.password.passw2="text";
            }
        },
        showPass3(){
　　　　　　 //点击图标是密码隐藏或显示
            if( this.password.passw3=="text"){
                this.password.passw3="password";
            }else {
                this.password.passw3="text";
            }
        },
        get_user_info:function(){
            this.$get(this.$api.userInfo).then(res=>{
                this.userInfo = res.data;
            });
        },
        submitForm:function(e){
            let _this = this;
            // 验证表单
            this.$refs[e].validate(function(res){
                if(res){
                    if(_this.info.newPassword != _this.info.repassword){
                        return _this.$message.error('两次密码不一致');
                    }
                    _this.info.mobile=_this.userInfo.mobile;
                    _this.edit_user_info();
                }
            });
        },
        edit_user_info:function(){
            this.$put(this.$api.modifyPawwword,{password:this.info.password, newPassword: this.info.newPassword}).then(res=>{
                if(res.code != 0){
                    return this.$message.error(res.msg);
                }
                this.$message.success('修改成功');
                _local.remove('token')
                _local.remove('user_info')
                _local.clear()
                this.$router.replace('/user/login');
                location.reload()
            });
        }
    },
    created() {
        this.get_user_info();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.admin_form_main .el-form-item /deep/ img{
    vertical-align: middle;
    margin-right: 8px;
    cursor: pointer;
}
</style>